module.exports = __webpack_public_path__ + "img/logo_navbar.42bac8cf.png";